import * as React from "react";
import Seo from "../components/seo";

const ProjectsPage = () => {
  return <p>owo</p>;
};

export default ProjectsPage;
